import Icon from "@mdi/react";
import React, { useEffect, useState } from "react";
import "../../assets/styles/components/counter.scss";
import { mdiMenuDown, mdiMenuLeft, mdiMenuRight, mdiMenuUp } from "@mdi/js";
import { Input } from "antd";

interface Props {
  vertical?: boolean;
  defaultValue?: number;
  length?: number;
  isTyping?: boolean;
  changeValue?: (number: number | string) => void;
  max?: number;
  fixed?: boolean;
  disabled?: boolean
}

const Counter: React.FC<Props> = ({
  vertical = false,
  defaultValue = 0,
  length = 0.05,
  max = 0,
  isTyping = false,
  changeValue,
  fixed = true,
  disabled = false
}) => {
  const mockDefaultValue = (fixed) ? defaultValue.toString() : defaultValue.toString().replace(/\.0+$/, '');
  const [value, setValue] = useState<string>(mockDefaultValue);

  function onIncrement() {
    if (disabled) return;
    if (max !== 0 && max - length >= parseFloat(value)) {
      if (fixed) {
        setValue((parseFloat(value) + length).toFixed(2));
        changeValue?.((parseFloat(value) + length).toFixed(2));
      } else {
        setValue((parseFloat(value) + length).toString());
        changeValue?.((parseFloat(value) + length).toString());
      }
    } else if(max === 0) {
      if (fixed) {
        setValue((parseFloat(value) + length).toFixed(2));
        changeValue?.((parseFloat(value) + length).toFixed(2));
      } else {
        setValue((parseFloat(value) + length).toString());
        changeValue?.((parseFloat(value) + length).toString());
      }
    }


  }
  function onDicrement() {
    if (disabled) return;
    if (parseFloat(value) <= 0) {
      setValue("0");
      changeValue?.(0);
    } else {
      if (parseFloat(value) - length <= 0) {
        setValue("0");
        changeValue?.(0);
      } else {
        if (fixed) {
          setValue((parseFloat(value) - length).toFixed(2));
          changeValue?.((parseFloat(value) - length).toFixed(2));
        } else {
          setValue((parseFloat(value) - length).toString());
          changeValue?.((parseFloat(value) - length).toString());
        }
      }
    }

  }

  useEffect(() => {
    console.log("value =>", typeof parseFloat(value));
    // setValue(value.toFixed(2));
  }, [value]);

  useEffect(() => {
    console.log("first");
  }, []);

  return (
    <div className="counter">
      {vertical ? (
        <div className="vertical">
          {isTyping ? (
            <>
              {
                <Input
                  value={value}
                  onChange={(e: any) => {
                    setValue(e.target.value);
                  }}
                  min="0"
                  step="0.05"
                  type="number"
                  disabled={disabled}
                />
              }
            </>
          ) : (
            <>{parseFloat(value).toFixed(2)}</>
          )}

          <div className="up-down">
            <div className="arrow" onClick={onIncrement}>
              <Icon path={mdiMenuUp} size="20" />
            </div>
            <div className="arrow" onClick={onDicrement}>
              <Icon path={mdiMenuDown} size="20" />
            </div>
          </div>
        </div>
      ) : (
        <div className="horizontal">
          <div className="arrow" onClick={onDicrement}>
            <Icon path={mdiMenuLeft} size="20" />
          </div>
          {value}
          <div className="arrow" onClick={onIncrement}>
            <Icon path={mdiMenuRight} size="20" />
          </div>
        </div>
      )}
    </div>
  );
};
export default Counter;
